<span class="hand" (click)="open()"> {{ translate | translate: { text: log.sticky.text } }}</span>
